import {
  staticWebsitesEndpoints,
  TGetWebsitesResponse,
  IGetWebsitesOptionsDTO,
  IDeleteWebsitesDTO,
  getWebsitesEndpoints,
  ICreateWebsitesDataDTO,
  ICreateWebsitesResponse,
  IUpdateWebsitesDataDTO,
  IUpdateWebsitesResponse,
  IReorderWebsitesDTO,
} from '@/models/websites.model';
import { ApiResponse, convertModelToFormData, httpClient } from '@/utils';

class WebsitesAPI {
  static getWebsites(data: IGetWebsitesOptionsDTO): ApiResponse<TGetWebsitesResponse> {
    const { GET_WEBSITES } = staticWebsitesEndpoints;
    return httpClient.get<TGetWebsitesResponse>(GET_WEBSITES, {
      params: data,
    });
  }

  static createWebsite(data: ICreateWebsitesDataDTO): ApiResponse<ICreateWebsitesResponse> {
    const { CREATE_WEBSITE } = staticWebsitesEndpoints;
    return httpClient.post<ICreateWebsitesResponse>(
      CREATE_WEBSITE,
      convertModelToFormData(data, new FormData(), '', true),
    );
  }

  static updateWebsite({ id, ...data }: IUpdateWebsitesDataDTO): ApiResponse<IUpdateWebsitesResponse> {
    const { UPDATE_WEBSITE } = getWebsitesEndpoints({ id: id! });
    return httpClient.patch<IUpdateWebsitesResponse>(
      UPDATE_WEBSITE,
      convertModelToFormData(data, new FormData(), '', true),
    );
  }

  static deleteWebsite({ id }: IDeleteWebsitesDTO) {
    const { DELETE_WEBSITE } = getWebsitesEndpoints({ id: id! });
    return httpClient.delete(DELETE_WEBSITE);
  }

  static reorderWebsites(data: IReorderWebsitesDTO): ApiResponse<TGetWebsitesResponse> {
    const { REORDER_WEBSITES } = staticWebsitesEndpoints;
    return httpClient.post<TGetWebsitesResponse>(REORDER_WEBSITES, data);
  }
}

export default WebsitesAPI;
